// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.row_border {\n  margin-top: 15px;\n  border-radius: 4px;\n  border: 1px solid #dcdfe6;\n}\n.memberEditinputText {\n  color: #000000 !important;\n  width: 220px !important;\n}\n", ""]);
// Exports
module.exports = exports;
